export default __webpack_public_path__ + "2edadd43f8e455a4fd981038dfdda8b7.woff";